import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const PaginatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin: ${pxToRem(29)};
  margin-bottom: ${pxToRem(25)};
  margin-top: ${pxToRem(36)};
`;

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${pxToRem(16)};
  flex: 1;

  span {
    color: rgb(185, 185, 185);
    font-size: ${pxToRem(20)};
    font-weight: 500;
    line-height: ${pxToRem(24)};
  }
`;

export const NavButtonsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
  align-items: center;
`;

export const PageButton = styled.button`
  border: none;
  font-size: ${pxToRem(20)};
  font-weight: 500;
  cursor: pointer;
  color: rgb(185, 185, 185);
  background: none;
  transition: background 0.2s;

  &:hover {
    transform: scale(1.05);
  }
`;

export const ActivePageButton = styled(PageButton)`
  color: rgb(0, 0, 0);
  font-weight: 500;
  line-height: ${pxToRem(24)};
  padding: ${pxToRem(4)} ${pxToRem(8)};
  border: ${pxToRem(1)} solid rgb(226, 226, 226);
  border-radius: ${pxToRem(8)};
  background: rgb(250, 250, 250);

  &:hover {
    transform: scale(1.05);
  }
`;

export const NavButton = styled.button<{ direction: "left" | "right" }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(24)};
  padding: ${pxToRem(8)} ${pxToRem(16)};
  border: ${pxToRem(1)} solid rgb(229, 229, 229);
  border-radius: ${pxToRem(8)};
  background: rgb(250, 250, 250);
  ${({ direction }) =>
    direction === "left" &&
    `
      flex-direction: row-reverse;
    `}

  font-size: ${pxToRem(20)};
  font-weight: 400;
  line-height: ${pxToRem(24)};
  color: rgb(0, 0, 0);

  &:hover {
    background: #f0f0f0;
  }

  &::after {
    content: "";
    display: inline-block;
    width: ${pxToRem(10)};
    height: ${pxToRem(10)};
    border: solid #333;
    border-width: 0 ${pxToRem(2)} ${pxToRem(2)} 0;
    transform: ${({ direction }) =>
      direction === "left" ? "rotate(135deg)" : "rotate(-45deg)"};
    transition: transform 0.2s;
  }
`;
